<template>
  <el-dialog
    class="schedule-entrance-test-dialog skip-entrance-test-dialog"
    :visible="visible"
    width="480px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div
      slot="title"
      class="schedule-entrance-test-dialog__header d-flex align-items-center justify-content-between px-4 py-3"
    >
      <h3 class="font-weight-bold mb-0">{{ title }}</h3>
      <button
        type="button"
        class="schedule-entrance-test-dialog__close btn p-0 d-inline-flex align-items-center justify-content-center"
        :disabled="loading"
        @click="handleClose"
      >
        <i class="el-icon-close"></i>
      </button>
    </div>

    <div class="schedule-entrance-test-dialog__body bg-white px-4 pt-4 pb-4">
      <template v-if="step === STEP_CONFIRM">
        <p class="skip-entrance-test-dialog__text mb-0">
          Học viên sẽ không tiếp tục bài kiểm tra đầu vào và chỉ được đăng ký khóa Bồi dưỡng nền tảng.
          Bạn có chắc chắn muốn bỏ qua?
        </p>
      </template>
      <template v-else>
        <p class="skip-entrance-test-dialog__text mb-0">
          Ca test đã được đóng. Bạn có thể tạo hợp đồng mức Bồi dưỡng nền tảng cho học viên.
        </p>
      </template>
    </div>

    <div slot="footer" class="schedule-entrance-test-dialog__footer d-flex justify-content-end">
      <template v-if="step === STEP_CONFIRM">
        <el-button class="schedule-entrance-test-dialog__cancel" :disabled="loading" @click="handleClose">
          Quay lại
        </el-button>
        <el-button
          class="schedule-entrance-test-dialog__confirm"
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="confirmSkip"
        >
          Xác nhận
        </el-button>
      </template>
      <template v-else>
        <el-button class="schedule-entrance-test-dialog__cancel" @click="handleClose">Đóng</el-button>
        <!-- <el-button class="schedule-entrance-test-dialog__confirm" type="primary" @click="goToCreateContract">
          Đặt lịch tư vấn
        </el-button> -->
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { UPDATE_NEED_ENTRANCE_EXAM } from "@/core/services/store/customer/entrance.module";

const STEP_CONFIRM = "confirm";
const STEP_SUCCESS = "success";

export default {
  name: "SkipEntranceTestDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customerId: {
      default: null
    }
  },
  data() {
    return {
      STEP_CONFIRM,
      step: STEP_CONFIRM,
      loading: false
    };
  },
  computed: {
    title() {
      return this.step === STEP_CONFIRM ? "Xác nhận bỏ qua bước kiểm tra" : "Đã bỏ qua bước kiểm tra";
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.step = STEP_CONFIRM;
        this.loading = false;
      }
    }
  },
  methods: {
    handleClose() {
      if (this.loading) return;
      this.$emit("update:visible", false);
    },
    confirmSkip() {
      if (this.loading) return;
      this.loading = true;
      this.$store
        .dispatch(UPDATE_NEED_ENTRANCE_EXAM, { customer_id: this.customerId })
        .then((res) => {
          if (res?.error) {
            this.$message({ type: "error", message: res.message || "Bỏ qua bước kiểm tra thất bại", showClose: true });
            return;
          }
          this.step = STEP_SUCCESS;
          this.$emit("skipped");
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error?.data?.message || "Bỏ qua bước kiểm tra thất bại",
            showClose: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goToCreateContract() {
      this.$emit("update:visible", false);
      this.$router.push({ name: "lich_tuvan" });
    }
  }
};
</script>

<style src="./entrance/entrance-dialog.css"></style>

<style scoped>
.skip-entrance-test-dialog__text {
  color: #3f3b48;
  font-size: 14px;
  line-height: 1.5;
  overflow-wrap: break-word !important;
  word-break: normal !important;
}
</style>
